import React from 'react';

const InvestorsForm = () => {
    return (
        <div>
            Investors Form
        </div>
    );
};

export default InvestorsForm;